<a *ngIf="!isKaiser()" 
    class="nav-link-test" 
    id="lnkSharedProviderLink" 
    target="_blank" 
    href="{{providerLink}}">{{providerName}}
</a>
<span *ngIf="isKaiser()"id="lnkSharedProviderName">{{providerName}}</span>